import { Reveal } from "@/components/Reveal";

const IMG_TEAM = "https://images.unsplash.com/photo-1541746972996-4e0b0f43e02a";

export default function About() {
  return (
    <section id="about" className="relative bg-[#050505] py-24 lg:py-32 border-t border-white/10" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
        <Reveal>
          <div className="relative overflow-hidden rounded-3xl border border-white/10">
            <img
              src={IMG_TEAM}
              alt="Agentica AI team"
              className="w-full h-[420px] object-cover grayscale brightness-75 contrast-110"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#050505]/70 to-transparent" />
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="flex items-center gap-3 mb-5">
            <span className="h-px w-10 bg-gradient-to-r from-[#4f6bff] to-[#9d6bff]" />
            <span className="overline text-[#8b7cff]/90">05 — Who we are</span>
          </div>
          <h2 className="font-display font-700 tracking-tighter leading-none text-white text-4xl sm:text-5xl mb-6">
            A studio built for the agentic era.
          </h2>
          <p className="text-white/60 leading-relaxed mb-5">
            Agentica AI Solutions is a boutique consulting and engineering startup founded by
            practitioners from applied research, platform engineering, and enterprise delivery.
            We exist to help organizations move past AI experiments and into dependable,
            autonomous systems.
          </p>
          <p className="text-white/60 leading-relaxed mb-8">
            Small, senior, and hands-on — you work directly with the people writing the code
            and shaping the strategy. No layers, no hand-offs, just outcomes.
          </p>
          <div className="grid grid-cols-3 gap-6 border-t border-white/10 pt-8">
            {[["Applied", "Research DNA"], ["Senior", "Only team"], ["Global", "Delivery"]].map(([a, b]) => (
              <div key={b}>
                <div className="font-display text-xl font-700 text-white tracking-tight">{a}</div>
                <div className="text-xs text-white/45 mt-1">{b}</div>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
